// extracted by mini-css-extract-plugin
export default {"disclaimerWrapper":"RecommendedStocksPage_disclaimerWrapper__moE94","disclaimerText":"RecommendedStocksPage_disclaimerText__cVLUN"};